module.exports = __webpack_public_path__ + "static/assets/1001c77efae36715de65fe1292fd3699.svg";